
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type relatedItemsRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function relatedItemsRT(): TemplateResult<relatedItemsRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function repeatBadge1(badge, badgeIndex) {
                    return _createElement('div', {
                        'className': 'badge cm_badge cm_badge__' + this.toKebabCase(badge),
                        'key': badge
                    }, '\n          ', badge, '\n        ');
                }
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                function repeatI3(i, iIndex) {
                    return _createElement('span', {
                        'key': i,
                        'className': 'cm_star cm_star__' + (!(this.review_average - i) || this.review_average - i < 0.25 ? 'empty' : this.review_average - i < 0.75 ? 'half' : 'full')
                    });
                }
                return _createElement('div', { 'className': 'cm_product-item grid-item__link' + (this.is_promotional_item ? ' cm_promotion' : '') }, _createElement('div', { 'className': 'cm_product-item__media' }, _createElement('a', {
                    'href': this.url,
                    'className': 'cm_product-item__image-container'
                }, _createElement('img', {
                    'className': 'cm_product-item__image' + (this.image2 ? ' cm_product-item__image_primary' : ''),
                    'src': this.imageOrDefault(this.resizeImage(this.image)),
                    'alt': this.removeHTML(this.title),
                    'onError': this.onImageError
                }), this.image2 ? _createElement('img', {
                    'className': 'cm_product-item__image cm_product-item__image_secondary',
                    'src': this.resizeImage(this.image2),
                    'alt': this.removeHTML(this.title),
                    'onError': e => this.onImageError(e, 'image2'),
                    'key': '469'
                }) : null, this._badges ? _createElement.apply(this, [
                    'div',
                    {
                        'className': 'cm_badge-container cm_badge-right',
                        'key': '701'
                    },
                    _map(this._badges, repeatBadge1.bind(this))
                ]) : null), _createElement('div', { 'className': 'cm_product-item__buttons' }, _createElement('form', {
                    'action': '/cart/add',
                    'method': 'post',
                    'className': 'cm_product-item__buttons-form',
                    'id': this.id,
                    'encType': 'multipart/form-data'
                }, this.variant_ids.length > 1 ? [_createElement('a', {
                        'className': 'cm_button cm_button__secondary',
                        'href': this.url,
                        'aria-label': 'button',
                        'key': '11261'
                    }, '\n            ', this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_select_options`), '\n          ')] : null, this.variant_ids.length === 1 ? [
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'id',
                        'value': this.variant_ids,
                        'key': '14241'
                    }),
                    _createElement('input', {
                        'type': 'hidden',
                        'name': 'quantity',
                        'value': this.set_qty || 1,
                        'key': '14243'
                    }),
                    this.fitsTheVehicle && !window.Convermax.config?.hideVerifyOnCartItems ? _createElement('input', {
                        'type': 'hidden',
                        'name': 'properties[Fitment]',
                        'value': this.getVerifyFitmentOrderNotes(this.fitsTheVehicle),
                        'key': '14245'
                    }) : null,
                    _createElement('button', {
                        'className': 'cm_button cm_button__primary',
                        'type': 'submit',
                        'data-form-id': this.id,
                        'disabled': this.out_of_stock,
                        'aria-label': this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_add_to_cart`),
                        'key': '14247'
                    }, this.out_of_stock ? [_translate(`product_out_of_stock`)] : null, !this.out_of_stock ? [[_createElement('svg', {
                                'className': 'cm_icon',
                                'width': '100%',
                                'height': '100%',
                                'viewBox': '0 0 18 18',
                                'fill': 'none',
                                'xmlns': 'http://www.w3.org/2000/svg',
                                'key': '22340'
                            }, _createElement('g', { 'clipPath': 'url(#clip0_30707_436)' }, _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M4.3158 1.00003C4.71767 0.999076 5.06951 1.28437 5.16953 1.69367L5.17043 1.69844L5.6823 3.84904H14.9159C15.6669 3.84999 16.3597 4.27363 16.7297 4.95965C17.0925 5.63326 17.0898 6.45667 16.7234 7.12551L15.1859 10.5546C15.175 10.5785 15.1641 10.6004 15.1514 10.6224C14.7823 11.2692 14.1222 11.67 13.4058 11.6843L5.8668 12.4953C5.84225 12.4982 5.81771 12.4991 5.79316 12.4991C4.64214 12.4991 3.70842 11.5202 3.70842 10.3113C3.70842 10.2798 3.71024 10.2484 3.71388 10.2169L4.37577 4.65908L3.86935 2.52565H1.72643C1.32548 2.52565 1 2.18408 1 1.76235C1 1.34157 1.32548 1 1.72643 1L4.3158 1.00003ZM5.75594 5.37563L5.16315 10.3504C5.18224 10.6872 5.44045 10.9572 5.7632 10.9725L13.2903 10.1634C13.3149 10.1605 13.3394 10.1596 13.3639 10.1596C13.5758 10.1596 13.7722 10.0479 13.8885 9.8638L15.4223 6.4452C15.4323 6.4223 15.4441 6.3994 15.456 6.37745C15.5732 6.17327 15.576 5.91852 15.4641 5.71147C15.3523 5.50347 15.1432 5.37561 14.9159 5.37561L5.75594 5.37563Z',
                                'fill': 'currentColor'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M6.88407 15.086H6.08672L6.88407 15.087C6.88207 16.1455 6.02484 17.001 4.96903 17C3.91223 16.999 3.05699 16.1405 3.05798 15.082C3.05798 14.0246 3.91422 13.167 4.97103 13.167H4.97203C5.00396 13.167 5.03489 13.168 5.06683 13.17C5.53986 13.194 5.98892 13.3929 6.32523 13.7297C6.37013 13.7747 6.41205 13.8217 6.45196 13.8706C6.73038 14.2124 6.88507 14.6412 6.88407 15.086ZM4.65368 15.083C4.65368 14.9081 4.79539 14.7652 4.97103 14.7652C4.97602 14.7652 4.98101 14.7652 4.986 14.7662C5.06483 14.7702 5.13968 14.8031 5.19556 14.8591C5.20255 14.8661 5.20953 14.8741 5.21652 14.8821C5.26342 14.9391 5.28837 15.011 5.28837 15.084C5.28837 15.2599 5.14567 15.4018 4.97102 15.4018C4.79539 15.4018 4.65368 15.2589 4.65368 15.083Z',
                                'fill': 'currentColor'
                            }), _createElement('path', {
                                'fillRule': 'evenodd',
                                'clipRule': 'evenodd',
                                'd': 'M11.4772 15.086H12.2753C12.2753 14.5783 12.0748 14.0895 11.7156 13.7297C11.3575 13.3699 10.8706 13.168 10.3628 13.167C9.30623 13.167 8.45022 14.0246 8.44922 15.082C8.44822 16.1405 9.30424 16.999 10.3598 17C11.4163 17.001 12.2733 16.1455 12.2753 15.087L11.4772 15.086ZM10.3618 14.7652C10.1872 14.7652 10.0445 14.9081 10.0445 15.083C10.0445 15.2589 10.1862 15.4019 10.3618 15.4019C10.5374 15.4019 10.679 15.2599 10.68 15.084C10.68 15.0001 10.6461 14.9191 10.5872 14.8591C10.5274 14.7992 10.4466 14.7652 10.3618 14.7652Z',
                                'fill': 'currentColor'
                            })), _createElement('defs', {}, _createElement('clipPath', { 'id': 'clip0_30707_436' }, _createElement('rect', {
                                'width': '18',
                                'height': '18',
                                'fill': 'white'
                            }))))]] : null)
                ] : null))), _createElement('div', { 'className': 'cm_product-item__details' }, this.vendor && this.vendor_url ? _createElement('a', mergeProps({
                    'href': this.vendor_url,
                    'className': 'cm_product-item__vendor',
                    'key': '5104'
                }, { dangerouslySetInnerHTML: { __html: typeof this.vendor === 'undefined' ? '' : this.vendor } })) : null, _createElement('a', mergeProps({
                    'href': this.url,
                    'className': 'cm_product-item__title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'cm_product-item__sku-container' }, this.sku ? _createElement('div', {
                    'className': 'cm_product-item__sku',
                    'key': '5578'
                }, _createElement('span', { 'className': 'sku-title' }, 'SKU: '), _createElement('span', mergeProps({ 'className': 'sku-value' }, { dangerouslySetInnerHTML: { __html: typeof this.sku === 'undefined' ? '' : this.sku } }))) : null), _createElement('div', { 'className': 'cm_product-item__price-container' }, this.on_sale ? _createElement('div', {
                    'className': 'cm_product-item__price-badge',
                    'key': '5911'
                }, '\n        ', _translate(`product_percent_off`, {  percent: Math.round((this.compare_at_price - this.price) * 100 / this.compare_at_price)  }), '\n      ') : null, this.on_sale ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_compare',
                    'key': '6134'
                }, '\n        ', this.formatPrice(this.compare_at_price), '\n      ') : null, _createElement('div', { 'className': 'cm_product-item__price' }, this.price_varies ? _createElement('span', { 'key': '6337' }, _translate(`price_from`), ' ') : null, '\n        ', this.formatPrice(this.min_price || this.price), '\n      '), this.set_qty && !this.price_varies ? _createElement('div', {
                    'className': 'cm_product-item__price cm_product-item__price_set',
                    'key': '6481'
                }, '\n        ', _translate(`product_set_of`, {  count: this.set_qty  }), ': ', this.formatPrice(this.price * this.set_qty), '\n      ') : null), _createElement('div', { 'className': 'cm_product-item__stock-status' + (this.out_of_stock ? ' cm_product-item__stock-status_out' : ' cm_product-item__stock-status_in') }, _createElement('span', { 'className': 'cm_product-item__stock-dot' }), _createElement('span', { 'className': 'cm_product-item__stock-label' }, this.out_of_stock ? _translate(`product_out_of_stock`) : _translate(`product_in_stock`)))), [this.review_count ? _createElement.apply(this, [
                        'div',
                        {
                            'className': 'cm_review-stars',
                            'key': '71150'
                        },
                        _map([
                            0,
                            1,
                            2,
                            3,
                            4
                        ], repeatI3.bind(this)),
                        _createElement('span', { 'className': 'cm_review-count' }, '(', this.review_count, ')')
                    ]) : null], this.price ? _createElement('p', {
                    'className': 'affirm-as-low-as',
                    'data-amount': this.price * 100,
                    'data-affirm-type': 'logo',
                    'data-affirm-color': 'blue',
                    'key': '7514'
                }) : null);
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_related-products' }, _createElement('div', { 'className': 'cm_related-products-title-container' }, _createElement('h2', { 'className': 'cm_related-products-title' }, _translate(`related_items_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_related-products-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]));
}
        export const componentNames = []